import { SmsAllocationOutput } from './sms-allocation-output.model';


export class SmsAllocationSelectByIdOutput implements ISmsAllocationSelectByIdOutput {
    status!: number;
    message!: string;
    data!: SmsAllocationOutput;

    constructor(data?: ISmsAllocationSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? SmsAllocationOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SmsAllocationSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SmsAllocationSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISmsAllocationSelectByIdOutput {
    status: number;
    message: string;
    data: SmsAllocationOutput;
}

